// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Task-module__tabsBox--dyAFV>div>div {
    display: flex;
    flex-wrap: wrap;
    margin-top: 16px;
}

.Task-module__tabsBox--dyAFV {
    max-width: 1000px;
}

.Task-module__statusIndicator--FHggq {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 5px;
}

.Task-module__blue--yHaqs {
    color: #0054E6;
}

.Task-module__green--u1rU_ {
    color: green;
}

.Task-module__red--DnOHv {
    color: red;
}

.Task-module__yellow--mrqSf {
    color: rgb(253, 177, 34);
}

.Task-module__blueIndicator--ADu9i {
    background-color: #0054E6;
}

.Task-module__greenIndicator--NIr4i {
    background-color: green;
}

.Task-module__redIndicator--xJnS7 {
    background-color: red;
}

.Task-module__yellowIndicator--z2Pwx {
    background-color: #ffc107;
}

.Task-module__status--KNShG {
    display: flex;
    gap: 16px;
}

.Task-module__statusBox--LmAwz {
    display: flex;
    gap: 30px;
    align-items: center;
}

.Task-module__statusBox--LmAwz>p {
    margin: 0 0 4px 0;
}



.Task-module__taskInfo--BjPqq {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    padding: 15px 20px;
    border-radius: 14px;
    -webkit-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    -moz-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    gap: 15px;
    min-height: 40vh;
    background-color: white;
    overflow: hidden;
}

.Task-module__infoBox--Whs_Z {
    margin-top: 20px;
    border-bottom: 1px solid #6f879c4b;
}

.Task-module__contentRow--StHBK {
    display: flex;
    gap: 40px;
}

.Task-module__contentRow--StHBK:not(:first-child) {
    margin-top: 20px;
}

.Task-module__contentColumn--b2PWI {
    display: flex;
    flex-direction: column;
    width: 280px;
}

.Task-module__contentColumn--b2PWI>span {
    color: #6F879C;
    font-size: 16px;
    border-bottom: 1px solid #6f879c4b;
}

.Task-module__contentColumn--b2PWI>p {
    font-weight: 500;
    color: #516372;
    margin-top: 5px;
    font-size: 18px;
}

.Task-module__historyStatus--xbS9u>.Task-module__title--Ew6N6 {
    color: #6F879C;
    font-size: 16px;
}

.Task-module__historyStatus--xbS9u>.Task-module__list--ISAhQ {
    font-weight: 500;
    color: #516372;
    margin-top: 5px;
    font-size: 18px;
}

.Task-module__btnBox--Ih9F0 {
    display: flex;
    margin-top: 20px;
    justify-content: center;
}

.Task-module__flexRowBox--fUwhD {
    display: flex;
    justify-content: space-between;
}

.Task-module__flexColumnBox--QxUXo {
    display: flex;
    flex-direction: column;
}

.Task-module__filesBox--phNMo {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.Task-module__filesBox--phNMo>a {
    display: flex;
    align-items: center;
    gap: 5px;
    max-height: 25px;
    color: var(--color-primary-30);
    background-color: var(--color-secondary-100);
    font-size: 14px;
    padding: 8px;
    border-radius: 14px;
    font-weight: 500;
    width: 400px;
    justify-content: center;
    background-color: #eff2ff7a;
    border-radius: 14px;
    box-shadow: inset 2px 2px 5px rgba(0, 0, 0, 0.2), inset -2px -2px 5px rgba(255, 255, 255, 0.7);
}

.Task-module__emptyBox--WCim4 {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
}

.Task-module__emptyBox--WCim4>p {
    font-size: 16px;
    color: #6f879c70;
    font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/pages/task/Task.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;;;AAIA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,4DAA4D;IAC5D,yDAAyD;IACzD,oDAAoD;IACpD,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,8BAA8B;IAC9B,4CAA4C;IAC5C,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,8FAA8F;AAClG;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".tabsBox>div>div {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin-top: 16px;\r\n}\r\n\r\n.tabsBox {\r\n    max-width: 1000px;\r\n}\r\n\r\n.statusIndicator {\r\n    display: inline-block;\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 50%;\r\n    margin-right: 5px;\r\n}\r\n\r\n.blue {\r\n    color: #0054E6;\r\n}\r\n\r\n.green {\r\n    color: green;\r\n}\r\n\r\n.red {\r\n    color: red;\r\n}\r\n\r\n.yellow {\r\n    color: rgb(253, 177, 34);\r\n}\r\n\r\n.blueIndicator {\r\n    background-color: #0054E6;\r\n}\r\n\r\n.greenIndicator {\r\n    background-color: green;\r\n}\r\n\r\n.redIndicator {\r\n    background-color: red;\r\n}\r\n\r\n.yellowIndicator {\r\n    background-color: #ffc107;\r\n}\r\n\r\n.status {\r\n    display: flex;\r\n    gap: 16px;\r\n}\r\n\r\n.statusBox {\r\n    display: flex;\r\n    gap: 30px;\r\n    align-items: center;\r\n}\r\n\r\n.statusBox>p {\r\n    margin: 0 0 4px 0;\r\n}\r\n\r\n\r\n\r\n.taskInfo {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-top: 30px;\r\n    padding: 15px 20px;\r\n    border-radius: 14px;\r\n    -webkit-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    -moz-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    gap: 15px;\r\n    min-height: 40vh;\r\n    background-color: white;\r\n    overflow: hidden;\r\n}\r\n\r\n.infoBox {\r\n    margin-top: 20px;\r\n    border-bottom: 1px solid #6f879c4b;\r\n}\r\n\r\n.contentRow {\r\n    display: flex;\r\n    gap: 40px;\r\n}\r\n\r\n.contentRow:not(:first-child) {\r\n    margin-top: 20px;\r\n}\r\n\r\n.contentColumn {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 280px;\r\n}\r\n\r\n.contentColumn>span {\r\n    color: #6F879C;\r\n    font-size: 16px;\r\n    border-bottom: 1px solid #6f879c4b;\r\n}\r\n\r\n.contentColumn>p {\r\n    font-weight: 500;\r\n    color: #516372;\r\n    margin-top: 5px;\r\n    font-size: 18px;\r\n}\r\n\r\n.historyStatus>.title {\r\n    color: #6F879C;\r\n    font-size: 16px;\r\n}\r\n\r\n.historyStatus>.list {\r\n    font-weight: 500;\r\n    color: #516372;\r\n    margin-top: 5px;\r\n    font-size: 18px;\r\n}\r\n\r\n.btnBox {\r\n    display: flex;\r\n    margin-top: 20px;\r\n    justify-content: center;\r\n}\r\n\r\n.flexRowBox {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.flexColumnBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.filesBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n}\r\n\r\n.filesBox>a {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n    max-height: 25px;\r\n    color: var(--color-primary-30);\r\n    background-color: var(--color-secondary-100);\r\n    font-size: 14px;\r\n    padding: 8px;\r\n    border-radius: 14px;\r\n    font-weight: 500;\r\n    width: 400px;\r\n    justify-content: center;\r\n    background-color: #eff2ff7a;\r\n    border-radius: 14px;\r\n    box-shadow: inset 2px 2px 5px rgba(0, 0, 0, 0.2), inset -2px -2px 5px rgba(255, 255, 255, 0.7);\r\n}\r\n\r\n.emptyBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.emptyBox>p {\r\n    font-size: 16px;\r\n    color: #6f879c70;\r\n    font-weight: 500;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabsBox": `Task-module__tabsBox--dyAFV`,
	"statusIndicator": `Task-module__statusIndicator--FHggq`,
	"blue": `Task-module__blue--yHaqs`,
	"green": `Task-module__green--u1rU_`,
	"red": `Task-module__red--DnOHv`,
	"yellow": `Task-module__yellow--mrqSf`,
	"blueIndicator": `Task-module__blueIndicator--ADu9i`,
	"greenIndicator": `Task-module__greenIndicator--NIr4i`,
	"redIndicator": `Task-module__redIndicator--xJnS7`,
	"yellowIndicator": `Task-module__yellowIndicator--z2Pwx`,
	"status": `Task-module__status--KNShG`,
	"statusBox": `Task-module__statusBox--LmAwz`,
	"taskInfo": `Task-module__taskInfo--BjPqq`,
	"infoBox": `Task-module__infoBox--Whs_Z`,
	"contentRow": `Task-module__contentRow--StHBK`,
	"contentColumn": `Task-module__contentColumn--b2PWI`,
	"historyStatus": `Task-module__historyStatus--xbS9u`,
	"title": `Task-module__title--Ew6N6`,
	"list": `Task-module__list--ISAhQ`,
	"btnBox": `Task-module__btnBox--Ih9F0`,
	"flexRowBox": `Task-module__flexRowBox--fUwhD`,
	"flexColumnBox": `Task-module__flexColumnBox--QxUXo`,
	"filesBox": `Task-module__filesBox--phNMo`,
	"emptyBox": `Task-module__emptyBox--WCim4`
};
export default ___CSS_LOADER_EXPORT___;
